import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ReportService } from "app/_services/report.service";

import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import { BsModalService } from "ngx-bootstrap";
import { ReportManagerService } from "./report-manager.service";
import { ProjectsService } from "app/_services/projects.service";
import * as html2pdf from "html2pdf.js";
const PDFMerger = require("pdf-merger-js/browser");
const moment = require("moment");
// // @ts-ignore
// import { PDFDocument } from 'pdf-lib';
@Component({
  selector: "app-report-manager",
  templateUrl: "./report-manager.component.html",
  styleUrls: ["./report-manager.component.scss"],
})
export class ReportManagerComponent implements OnInit {
  isLoading = false;
  brandDropDownSettings: any;
  brandSelected = [];
  brands = [];
  listDataReport = Array();
  dataReport: Object;
  projectDropDownSettings: any;
  projectSelected = [];
  projects = [];
  showTab1 = true;
  showTab2 = true;
  showTab3 = true;
  report_name = "Report";
  typeReports = [
    {
      id: "QLML",
      itemName: "Mục lục, lời chào, cám ơn",
      value: " Mục lục, lời chào, cám ơn",
    },
    {
      id: "BCTQ",
      itemName: "Tổng quan",
      value: " Tổng quan",
    },
    {
      id: "DBTL",
      itemName: "Diễn biến thảo luận",
      value: " Diên biến thảo luận",
    },
    {
      id: "BCST",
      itemName: "Sắc thái",
      value: "Sắc thái",
    },
    {
      id: "BCNDL",
      itemName: "Nguồn dữ liệu",
      value: "Nguồn dữ liệu",
    },
    {
      id: "BCNDTLNB",
      itemName: "Báo cáo nội dung thảo luận nổi bật về thương hiệu",
      value: "Báo cáo nội dung thảo luận nổi bật về thương hiệu",
    },
    {
      id: "BCTCD",
      itemName: "Báo cáo Top nội dung thảo luận nhiều nhất",
      value: "Báo cáo Top nội dung thảo luận nhiều nhất",
    },
    {
      id: "BCCTND",
      itemName: "Báo cáo chi tiết nội dung theo chủ đề",
      value: "Báo cáo chi tiết nội dung theo chủ đề",
    },
    {
      id: "SSTH",
      itemName: "Báo cáo so sánh thương hiệu",
      value: "Báo cáo so sánh thương hiệu",
    },
    {
      id: "BCNBTH",
      itemName: "Báo cáo nổi bật thương hiệu",
      value: "Báo cáo nổi bật thương hiệu",
    },
    {
      id: "BCSSSTTLTH",
      itemName: "Báo cáo so sánh sắc thái thảo luận các thương hiệu",
      value: "Báo cáo so sánh sắc thái thảo luận các thương hiệu",
    },
    {
      id: "BCDBTLVCTH",
      itemName: "Báo cáo diễn biến thảo luận về các thương hiệu",
      value: "Báo cáo diễn biến thảo luận về các thương hiệu",
    },
    {
      id: "BCSSSKTH",
      itemName: "Báo cáo so sánh sức khỏe các thương hiệu",
      value: "Báo cáo so sánh sức khỏe các thương hiệu",
    },
    {
      id: "BCKTL",
      itemName: "Báo cáo kênh thảo luận",
      value: "Báo cáo kênh thảo luận",
    },
    {
      id: "BCHQHTBD",
      itemName: "Báo cáo hiệu quả bài đăng trên Fanpage",
      value: "Báo cáo hiệu quả bài đăng trên Fanpage",
    },
    {
      id: "BCCDNTL",
      itemName: "Báo cáo chân dung người dùng thảo luận",
      value: "Báo cáo chân dung người dùng thảo luận",
    },
    {
      id: "BCSSHTBD",
      itemName: "Báo cáo so sánh bài đăng trên Fanpage",
      value: "Báo cáo so sánh bài đăng trên Fanpage",
    },
    {
      id: "BCTPTL",
      itemName: "Báo cáo thị phần thảo luận các thương hiệu",
      value: "Báo cáo thị phần thảo luận các thương hiệu",
    },
    {
      id: "BCSSNBD",
      itemName: "Báo cáo so sánh nguồn bài đăng",
      value: "Báo cáo so sánh nguồn bài đăng",
    },
    {
      id: "BCCSCX",
      itemName: "Báo cáo chỉ số cảm xúc",
      value: "Báo cáo chỉ số cảm xúc",
    },
    {
      id: "BCTTLVXHTL",
      itemName: "Báo cáo tổng thảo luận và xu hướng thảo luận",
      value: "Báo cáo tổng thảo luận và xu hướng thảo luận",
    },
    {
      id: "BCTLTH",
      itemName: "Báo cáo thảo luận truyền hình",
      value: "Báo cáo thảo luận truyền hình",
    },
    {
      id: "BCTLTL",
      itemName: "Báo cáo tổng lượng thảo luận",
      value: "Báo cáo tổng lượng thảo luận",
    },
  ];
  typeReportSelecteds = Array();
  typeDropDownSettings: any;

  typeReport = "day";

  reportName = "";
  reports = Array();

  currentConfigItem = {
    projects: [],
    name: "",
    type: "BRAND",
  };
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  currentIndex = -1;
  currentDetail = {};
  listReports = [];
  listReportsSelected = [];
  dataTableShow = false;
  showReport = false;
  modalRef: BsModalRef;
  isEdit = false;
  public daterange: any = {
    start: moment().subtract(1, "days").startOf("day"),
    end: moment().subtract(1, "days").endOf("day"),
  };
  options = {
    locale: { format: "DD/MM/YYYY" },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf("day").toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end,
  };
  headerReport = [];
  discussProject = [];

  selectedProjects = [];
  selectedDiscussProjects = [];
  configAngularMultiSelect = {
    singleSelection: false,
    text: "Chọn",
    selectAllText: "Chọn tất cả",
    unSelectAllText: "Bỏ chọn tất cả",
    enableSearchFilter: true,
    badgeShowLimit: 5,
  };
  merger = new PDFMerger();
  constructor(
    private modalService: BsModalService,
    private toastrService: ToastrService,
    private reportManagerService: ReportManagerService,
    private projectsService: ProjectsService
  ) {
    this.getProject();
    this.getBrands();
    this.getAllReport();
  }
  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf("day");
    datepicker.end = value.end.endOf("day");
    this.daterange.start = value.start;
    this.daterange.end = value.end;
  }
  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: false,
      text: "Chọn thương hiệu",
      selectAllText: "Chọn tất cả",
      unSelectAllText: "Bỏ chọn tất cả",
      enableSearchFilter: false,
      badgeShowLimit: 1,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: "Chọn chủ đề",
      selectAllText: "Chọn tất cả",
      unSelectAllText: "Bỏ chọn tất cả",
      enableSearchFilter: false,
      badgeShowLimit: 1,
    };
    this.typeDropDownSettings = {
      singleSelection: false,
      text: "Chọn báo cáo",
      selectAllText: "Chọn tất cả",
      unSelectAllText: "Bỏ chọn tất cả",
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: "full_numbers",
      ordering: false,
      searching: true,
      paging: false,
      language: {
        infoEmpty: "Không tìm thấy dữ liệu",
        infoFiltered: "(trong _MAX_ )",
        info: "Hiển thị _START_ - _END_ trên _TOTAL_",
        lengthMenu: "Hiển thị _MENU_ ",
        search: "Tìm kiếm",
        zeroRecords: "Không có dữ liệu !",
        paginate: {
          first: "<<",
          previous: "<",
          next: ">",
          last: ">>",
        },
      },
      columnDefs: [{ targets: [0], searchable: false }],
    };
    this.dtOptions2 = {
      pagingType: "full_numbers",
      ordering: false,
      searching: true,
      paging: true,
      language: {
        infoEmpty: "Không tìm thấy dữ liệu",
        infoFiltered: "(trong _MAX_ )",
        info: "Hiển thị _START_ - _END_ trên _TOTAL_",
        lengthMenu: "Hiển thị _MENU_ ",
        search: "Tìm kiếm",
        zeroRecords: "Không có dữ liệu !",
        paginate: {
          first: "<<",
          previous: "<",
          next: ">",
          last: ">>",
        },
      },
      columnDefs: [{ targets: [0, 1, 2, 3], searchable: true }],
    };
    // this.getDataFromServer();
  }

  getBrands() {
    this.dataTableShow = false;
    this.reportManagerService.getBrands().subscribe((res) => {
      if (res.success) {
        res.data.forEach((element) => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name,
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error(
          "Lỗi hệ thống, Vui lòng liên hệ admin",
          " Thông báo"
        );
      }
    });
  }

  getSentimentDocCount(buckets, type = "neg") {
    let typeCount = 0;
    let total_count = 0;
    buckets.forEach((bucket) => {
      if (bucket.key == type) {
        typeCount = bucket.doc_count;
      }
      total_count += bucket.doc_count;
    });
    return Number(((typeCount / total_count) * 100).toFixed(2));
  }

  exportExcel() {}

  async exportPDF(item) {
    this.getDataReportItem(item);
    this.merger.reset();
    this.merger.setMetadata({
      author: "SocialNet",
      title: `${this.report_name}`,
    });
    const canvasMaxHeight = 31416;
    const width = 1587;

    let height = 1122;
    let currentChunk = 0;
    let totalChunks = 0;
    this.isLoading = true;
    let totalExported = 0;
    let clientHeight = 0;
    let pages = Array.from(
      window.document.getElementsByClassName("container-page")
    );

    for (const page of pages) {
      console.log(page.getBoundingClientRect());
      // if (element.clientWidth > width)
      //   width = element.clientWidth;
      clientHeight = page.clientHeight;
      if (page.clientHeight > height) {
        height = canvasMaxHeight;
        totalChunks = Math.ceil(page.clientHeight / canvasMaxHeight) - 1;
      }
      const config = {
        currentChunk: currentChunk,
        chunkHeight: height,
        totalChunks: totalChunks,
        clientHeight: clientHeight,
      };
      await this.getAllPdfPage(config, page);
      totalExported++;
      if (totalExported == pages.length) this.isLoading = false;
    }

    const blob = await this.merger.saveAsBlob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${this.report_name}`;

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  async getAllPdfPage(
    config: {
      currentChunk: number;
      chunkHeight: number;
      totalChunks: number;
      clientHeight: number;
    },
    page: any
  ) {
    let { currentChunk, chunkHeight, totalChunks, clientHeight } = config;
    if (currentChunk > totalChunks) return;
    if (currentChunk <= totalChunks) {
      if (totalChunks > 0) {
        clientHeight = clientHeight + 1200 * totalChunks; // bù số pixel bị mất do page break
      }
      let scrollY = currentChunk * chunkHeight;
      const options = {
        margin: 0,
        filename: `${this.report_name}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          dpi: 250,
          scrollX: 0,
          scrollY: -scrollY,
          scale: 1,
          width: 1587,
          height:
            totalChunks > currentChunk
              ? chunkHeight
              : clientHeight - currentChunk * chunkHeight,
        },
        jsPDF: { orientation: "landscape", format: "a3" },
        pagebreak: { avoid: "tr" },
      };
      const worker = await html2pdf()
        .set(options)
        .from(page)
        .output("arraybuffer");
      // const test = await html2pdf().set(options).from(page).toPdf().save();
      await this.merger.add(worker);
      currentChunk++;
      await this.getAllPdfPage({ ...config, currentChunk: currentChunk }, page);
    }
  }

  getDataReportItem(item) {
    this.isLoading = true;
    const id = item._id;
    this.reportManagerService.getDetailReport(id).subscribe((response) => {
      this.isLoading = false;
      if (response.success) {
        this.report_name = response.data.name;
        this.listDataReport = response.data.data;
      }
    });
  }

  deleteReportHandler() {
    this.isLoading = true;
    const id = this.currentDetail["_id"];
    this.reportManagerService.deleteReportItem(id).subscribe((response) => {
      this.isLoading = false;
      if (response.success) {
        this.toastrService.success("Xóa thành công", " Thông báo");
        this.getAllReport();
      }
      this.modalRef.hide();
    });
  }

  showConfirmDeleteReport(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: "static",
      class: "modal-md",
    });
    this.currentDetail = JSON.parse(JSON.stringify(item));
  }

  getProject() {
    this.projectsService.index().subscribe((response) => {
      if (response.success) {
        response.data.projects.forEach((element) => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name,
          };
          this.projects.push(projectItem);
        });
      }
    });
  }
  showDetailReport(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: "static",
      class: "modal-lg",
    });
    this.currentDetail = item;
  }
  getAllReport() {
    this.showTab2 = false;
    this.reportManagerService.getAllReport().subscribe((response) => {
      if (response.success) {
        this.reports = response.data;
        this.showTab2 = true;
      }
    });
  }

  getDataFromServer() {
    if (this.typeReportSelecteds.length == 0) {
      this.toastrService.warning("Bạn chưa chọn báo cáo!", "Thông báo");
    }
    let filter = {};
    let type = Array();
    for (var i = 0; i < this.typeReportSelecteds.length; i++) {
      type.push(this.typeReportSelecteds[i]["id"]);
    }

    filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      typeReport: this.typeReport,
      report_code: type,
    };

    this.dataTableShow = false;
    this.reportManagerService.getAll(filter).subscribe((res) => {
      if (res.success) {
        this.dataTableShow = true;
        this.listReports = res.data;
      } else {
        this.toastrService.error(
          "Lỗi hệ thống, Vui lòng liên hệ admin",
          " Thông báo"
        );
      }
    });
  }

  clickSaveReport(modalRef) {
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  createReport() {
    if (this.reportName.length == 0) {
      this.toastrService.warning("Bạn phải nhập tên báo cáo!", "Thông báo");
      return;
    }
    let data = {
      name: this.reportName.trim(),
      data: JSON.parse(JSON.stringify(this.listReportsSelected)),
    };

    this.reportManagerService.createReport(data).subscribe((response) => {
      if (response.success) {
        this.toastrService.success("Tạo mới báo cáo thành công!", "Thông báo!");
        this.listReportsSelected = [];
        this.getAllReport();
        this.closeModal();
      } else {
        this.toastrService.error(response.msg, "Thông báo!");
      }
    });
  }
  clickEditItem(item, modalRef) {
    this.isEdit = true;
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.currentConfigItem.projects = [];
    this.selectedProjects = [];
    item.projects.forEach((project) => {
      this.selectedProjects.push({
        id: project.projectId,
        itemName: project.projectName,
        value: project.projectName,
      });
    });
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: "static",
      class: "modal-lg",
    });
  }

  clickAddItem(item) {
    let check = true;
    for (var i = 0; i < this.listReportsSelected.length; i++) {
      if (item._id == this.listReportsSelected[i]._id) {
        check = false;
      }
    }
    if (check) {
      this.listReportsSelected.push(JSON.parse(JSON.stringify(item)));
    } else {
      this.toastrService.warning(
        "Báo cáo đã được chọn, vui lòng chọn báo cáo khác",
        "Thông báo!"
      );
    }

    for (var i = 0; i < this.listReports.length; i++) {
      if (item._id == this.listReports[i]._id) {
        this.listReports.splice(i, 1);
      }
    }
  }
  removeItem(item) {
    for (var i = 0; i < this.listReportsSelected.length; i++) {
      if (item._id == this.listReportsSelected[i]._id) {
        this.listReportsSelected.splice(i, 1);
      }
    }
    let check = true;
    for (var i = 0; i < this.listReports.length; i++) {
      if (item._id == this.listReports[i]._id) {
        check = false;
      }
    }
    if (check) {
      this.listReports.push(JSON.parse(JSON.stringify(item)));
    }
  }
  drag(ev) {
    this.currentIndex = Number(ev.target.id);
    console.log(ev.target.id);
    ev.dataTransfer.setData("text", ev.target.id);
  }
  onDragEnd(ev) {
    ev.preventDefault();
    this.currentIndex = -1;
  }
  allowDrop(ev) {
    ev.preventDefault();
  }
  drop(ev) {
    this.currentIndex = -1;
    ev.preventDefault();
    console.log(ev.target.id);
    var _oldIndex = Number(ev.dataTransfer.getData("text"));
    const _newIndex = Number(ev.target.id);
    if (_oldIndex >= 0 && _newIndex >= 0) {
      var temp = this.listReportsSelected[_newIndex];
      this.listReportsSelected[_newIndex] = this.listReportsSelected[_oldIndex];
      this.listReportsSelected[_oldIndex] = temp;
    }
  }
  deletePartOfTheReport(_id) {
    this.reportManagerService
      .deletePartReport(this.currentDetail["_id"], _id)
      .subscribe((res) => {
        if (res.success) {
          this.currentDetail["data"] = this.currentDetail["data"].filter(
            function (obj) {
              return obj._id !== _id;
            }
          );
        }
      });
  }
  clickDeleteItem(modalRef) {
    this.modalRef = this.modalService.show(modalRef);
  }

  closeModal() {
    this.modalRef.hide();
  }

  onItemSelect(item: any) {}
  OnItemDeSelect(item: any) {}

  onSelectAll(items: any) {}

  onDeSelectAll(items: any) {}
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/report-manager/report-manager.component.ts